<template>
  <el-dialog
    title="提出异议"
    :visible.sync="dialogVisible"
    width="640px"
    append-to-body
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form label-width="88px" size="small">
      <el-form-item label="对账单号">
        <span>{{ docNumber || '--' }}</span>
      </el-form-item>
      <el-form-item label="异议说明" required>
        <el-input
          v-model="remark"
          type="textarea"
          :rows="4"
          maxlength="512"
          show-word-limit
          placeholder="请填写异议说明"
        />
      </el-form-item>
      <el-form-item label="异议附件">
        <el-button size="mini" type="primary" plain @click="openUpload">
          {{ fileList.length ? `附件(${fileList.length})` : '上传附件' }}
        </el-button>
      </el-form-item>
    </el-form>

    <el-dialog
      title="异议附件"
      :visible.sync="uploadVisible"
      width="720px"
      append-to-body
      :close-on-click-modal="false"
      @close="closeUpload"
    >
      <myUploadTable
        :list="fileList"
        :type="3"
        :status="0"
        @uploadSuccess="syncFiles"
        @uploadDelete="syncFiles"
      />
    </el-dialog>

    <div slot="footer">
      <el-button size="small" @click="handleClose">取消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submitting"
        @click="handleSubmit"
      >
        提交异议
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { pmgtPurchasesStatementDoc_objectStatement } from '@/api/myController/outsourcing'
import {
  buildObjectStatementPayload,
  parseObjectionFileList,
} from '@/utils/outsourcingStatement'

export default {
  name: 'StatementObjectDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      uploadVisible: false,
      submitting: false,
      remark: '',
      fileList: [],
    }
  },
  computed: {
    docNumber() {
      return this.row && this.row.purchasesStatementDocNumber
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.remark = (this.row && this.row.valueSupplierObjectionRemark) || ''
        this.fileList = parseObjectionFileList(
          this.row && this.row.valueSupplierObjectionFileList
        )
      }
    },
    dialogVisible(val) {
      if (!val) this.$emit('update:visible', false)
    },
  },
  methods: {
    openUpload() {
      this.uploadVisible = true
    },
    closeUpload() {
      this.uploadVisible = false
    },
    syncFiles(list) {
      this.fileList = list || []
    },
    handleClose() {
      this.dialogVisible = false
      this.uploadVisible = false
      this.remark = ''
      this.fileList = []
      this.$emit('update:visible', false)
    },
    handleSubmit() {
      const remark = (this.remark || '').trim()
      if (!remark) {
        this.$message.warning('请填写异议说明')
        return
      }
      const id = this.row && this.row.purchasesStatementDocId
      if (!id) {
        this.$message.warning('缺少对账单标识')
        return
      }
      this.submitting = true
      pmgtPurchasesStatementDoc_objectStatement(
        {
          dto: buildObjectStatementPayload({
            purchasesStatementDocId: id,
            valueSupplierObjectionRemark: remark,
            fileList: this.fileList,
          })
        }
      )
        .then((res) => {
          if (res.data && res.data.success === false) {
            this.$message.error(res.data.errorMessage || '提交异议失败')
            return
          }
          this.$message.success('异议已提交')
          this.$emit('success')
          this.handleClose()
        })
        .finally(() => {
          this.submitting = false
        })
    },
  },
}
</script>
